import dynamic from 'next/dynamic';

const FeaturedFlight = dynamic(() => import('./FeaturedFlight'));

export default FeaturedFlight;
